// Generated by scripts/generate_static_demo_mocks.py from data/backups/api-export/
// (real API responses captured from a dev company-router). Do not edit by hand.
// Real answers from the alert-review model for the tour's watch prompts,
// replayed instead of calling a model: first round with the clarifying
// questions, and (handled in static_demo.ts) question-free once the
// clarification transcript is non-empty. Keyed by process slug.
import type { components as CompanyRouterComponents } from "../openapi/company-router";

type AlertReviewResponse = CompanyRouterComponents["schemas"]["AlertReviewResponse"];

export const demoAlertReviews: Record<string, AlertReviewResponse> = {
  "purchase-requisition-creation": {
    title: "External vs Contracted Contractor Use",
    prompt:
      "For the two procurement users, identify all purchase requisitions in the last 30 days where an external (non-contracted) contractor was selected despite a contracted contractor being available for that purchase category or scope of work.",
    questions: [
      {
        id: "contracted_signal",
        question: "How should the analyst detect that a contracted contractor was available?",
        dimension: "definition",
        options: [
          {
            label: "Approved vendor list in system",
            description:
              "Flag requisitions where the chosen vendor is absent from an approved/contracted vendor list visible in the procurement system.",
            answer:
              "A contracted contractor was available if a vendor in the same category or commodity code appears on the approved vendor list shown in the procurement system, and the requisition used a vendor not on that list.",
            recommended: true,
          },
          {
            label: "Same commodity code has contract",
            description:
              "Flag requisitions where another active contract exists for the same commodity or service code at the time of the requisition.",
            answer:
              "A contracted contractor was available if, at requisition creation, an active contract for the same commodity or service code was present in the system, and the selected vendor is not that contracted party.",
            recommended: false,
          },
          {
            label: "Manual override or bypass step",
            description:
              "Flag requisitions where the user skipped or overrode a contract-check or preferred-vendor step during the workflow.",
            answer:
              "A contracted contractor was available if the requisition workflow shows a contract-check or preferred-vendor prompt that was dismissed, skipped, or overridden before selecting the external vendor.",
            recommended: false,
          },
        ],
      },
    ],
    scope: {
      user_ids: ["00058000-1bf3-80cb-9baa-478c39a12dbf", "00058000-1cd6-83c9-ab07-e08b8561bf64"],
      process_slugs: [],
      window_days: 30,
      schedule_every_days: 7,
    },
  },
  "accounts-payable-exception-handling": {
    title: "Recurring Invoice PO Price Mismatches",
    prompt:
      "Which items appear repeatedly in invoice PO price mismatches? List each item, how often it recurs, and any observable pattern (e.g. vendor, PO line, product category) that could explain why the mismatch keeps happening.",
    questions: [
      {
        id: "threshold",
        question: "What makes a mismatch count as 'recurring'?",
        dimension: "definition",
        options: [
          {
            label: "2+ times",
            description: "Flag any item that mismatches at least twice in the window.",
            answer:
              "An item is recurring if it appears in a price mismatch 2 or more times within the lookback period.",
            recommended: true,
          },
          {
            label: "3+ times",
            description: "Flag only items that mismatch three or more times.",
            answer:
              "An item is recurring if it appears in a price mismatch 3 or more times within the lookback period.",
            recommended: false,
          },
          {
            label: "Any repeat across separate invoices",
            description:
              "Flag items that mismatch on more than one distinct invoice, regardless of count.",
            answer:
              "An item is recurring if it appears in a price mismatch on at least 2 distinct invoices within the lookback period.",
            recommended: false,
          },
        ],
      },
    ],
    scope: {
      user_ids: ["00058000-1d99-822f-9bff-ac78a5590aeb"],
      process_slugs: [],
      window_days: 30,
      schedule_every_days: 7,
    },
  },
};
